import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const getMonitoringDocuments = createAsyncThunk(
    'financeMonitoringDocuments/getMonitoringDocuments',
    async (data, { rejectWithValue }) => {
        const api = '/documents/getMonitoringDocument?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return {
                    documents: response.data.data,
                    total: response.data.paginator.total,
                };
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

export const executeKitchenShutoff = createAsyncThunk(
    'financeMonitoringDocuments/executeKitchenShutoff',
    async (data, { rejectWithValue }) => {
        const api = '/documents/executeKitchenShutoff?XDEBUG_SESSION_START=MyVSCode';

        try {
            const response = await apiInstance.post(api, JSON.stringify({ data }));

            if (response.data.result) {
                return response.data.data;
            } else {
                return rejectWithValue('Failed to fetch data');
            }
        } catch (error) {
            console.error('Ошибка при выполнении запроса:', error);
            return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
        }
    }
);

const initialState = {
    getMonitoringDocumentsStatus: null,
    executeKitchenShutoffStatus: null,
    monitoringDocuments: [],
    totalMonitoringDocuments: 0,
    currentMonitoringDocumentsPage: 1,
};

const deliveryMonitoringDocumentsSlice = createSlice({
    name: 'deliveryMonitoringDocuments',
    initialState,
    extraReducers: (builder) => {
        builder
            // getMonitoringDocuments
            .addCase(getMonitoringDocuments.pending, (state) => { state.getMonitoringDocumentsStatus = 'pending'; })
            .addCase(getMonitoringDocuments.fulfilled, (state, action) => {
                state.getMonitoringDocumentsStatus = 'fulfilled';
                state.monitoringDocuments = action.payload.documents;
                state.totalMonitoringDocuments = action.payload.total;
            })
            .addCase(getMonitoringDocuments.rejected, (state) => { state.getMonitoringDocumentsStatus = 'rejected'; })

            // executeKitchenShutoff
            .addCase(executeKitchenShutoff.pending, (state) => { state.executeKitchenShutoffStatus = 'pending'; })
            .addCase(executeKitchenShutoff.fulfilled, (state, action) => { state.executeKitchenShutoffStatus = 'fulfilled'; })
            .addCase(executeKitchenShutoff.rejected, (state) => { state.executeKitchenShutoffStatus = 'rejected'; })

            // PURGE
            .addCase(PURGE, () => { return initialState; })
    },
    reducers: {
        setCurrentMonitoringDocumentsPage: (state, action) => {
            state.currentMonitoringDocumentsPage = action.payload;
        },
        reset: (state) => {
            state.getMonitoringDocumentsStatus = null;
            state.monitoringDocuments = [];
            state.totalMonitoringDocuments = 0;
            state.currentMonitoringDocumentsPage = 1;
        },
    },
});

export const {
    setCurrentMonitoringDocumentsPage,
    reset,
} = deliveryMonitoringDocumentsSlice.actions;

export default deliveryMonitoringDocumentsSlice.reducer;
